module.exports = __webpack_public_path__ + "static/media/Logo_BQ.0268b4ca.png";